import { fadeIn, fadeOut } from "./Helpers/animations";

const contactUsForm: HTMLFormElement | null = document.getElementById('contactUsForm') as HTMLFormElement | null;

if (contactUsForm) {    
    const contactUsBody: HTMLTextAreaElement | null = document.getElementById('contactUsBody') as HTMLTextAreaElement | null;
    const contactUsBodyCharCount: HTMLSpanElement | null = document.getElementById('contactUsBodyCharCount');
    const formInputs: NodeListOf<HTMLInputElement | HTMLTextAreaElement> = contactUsForm.querySelectorAll('input, textarea');
    const formButtons: HTMLButtonElement | null = contactUsForm.querySelector('button');
    const submitOverlay: HTMLDivElement | null = contactUsForm.querySelector('.submit-overlay');
    const submitOverlayParagraph: HTMLParagraphElement | null | undefined = submitOverlay?.querySelector('p');
    const errorDialog: HTMLDivElement | null = document.getElementById('errorDialog') as HTMLDivElement | null;
    const successDialog: HTMLDivElement | null = document.getElementById('successDialog') as HTMLDivElement | null;
    const tokenInput: HTMLInputElement | null = document.getElementById('reCaptchaToken') as HTMLInputElement | null;

    if (tokenInput && successDialog && errorDialog) {
        const fadeInDialog = (dialog: HTMLDivElement) => {
            fadeOut(contactUsForm, 200, {
                callback: () => {
                    fadeIn(dialog, 200);
                    dialog.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        };

        if (contactUsBody && contactUsBodyCharCount) {
            contactUsBody.addEventListener('input', () => {
                contactUsBodyCharCount.innerText = `${4000 - contactUsBody.value.length}`;

                contactUsBody.value.length === 4000 ?
                    contactUsBodyCharCount.classList.add('font-weight-600', 'error') :
                    contactUsBodyCharCount.classList.remove('font-weight-600', 'error');
            });
        }

        contactUsForm?.addEventListener('submit', event => {
            event.preventDefault();
            formInputs.forEach(formInput => formInput.setAttribute('readonly', 'true'));
            formButtons?.setAttribute('disabled', 'true');

            if (submitOverlay && submitOverlayParagraph) {
                fadeIn(submitOverlay, 200);
                submitOverlayParagraph.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(contactUsForm.dataset?.recaptchakey ?? '', { action: 'contactUs' })
                .then(async token => {
                    tokenInput.value = token;

                    try {
                        const response = await fetch(contactUsForm.action, { 
                            method: 'POST',
                            body: new FormData(contactUsForm)
                        });
                        
                        if (response && response.status === 200 && response.statusText === 'message-sent') {
                            fadeInDialog(successDialog);
                        } else {
                            fadeInDialog(errorDialog);
                        }
                    } catch {
                        fadeInDialog(errorDialog);
                    }
                })
            });
        });
    }
}
 